import { on } from '@ngrx/store';

import { NewOpportunityLocationsActions } from 'src/app/new-opportunity/new-opportunity-locations/new-opportunity-locations.actions';
import { LoadingState } from 'src/app/utilities/state.util';

import { JobLocationsOverviewActions } from '../../job-overview/overview-locations/overview-locations.actions';
import { NewOpportunityCard, JobToolState } from '../../job-tool.reducer';
import { JobCreateActions } from '../job-create-state/job-create.actions';
import { JobManuallyAddLocationActions } from '../job-manually-add-location/job-manually-add-location.actions';
import { jobManuallyAddLocationInitialState } from '../job-manually-add-location/job-manually-add-location.state';

import { JobCreateLocationsActions } from './job-create-locations-state.actions';

export const jobCreateLocationsReducers = [
  on(
    JobCreateLocationsActions.googleAutocompleteAddressSelected,
    JobLocationsOverviewActions.googleAutocompleteAddressSelected,
    NewOpportunityLocationsActions.googleAutocompleteAddressSelected,
    (state: JobToolState, { address, locationType }): JobToolState => {
      // If selected addres is somehow invalid/unparsable, prompt user to enter address manually
      if (!('address_components' in address)) {
        return {
          ...state,
          manuallyAddLocationDialogVisible: true,
          manuallyAddLocationDialog: {
            ...jobManuallyAddLocationInitialState.manuallyAddLocationDialog,
            showAddressNotRecognizedWarning: true,
            locationType,
          }
        };
      }

      let ServiceArea = state.callState.ServiceArea;

      if (locationType === 'start') {
        ServiceArea = LoadingState.LOADING;
      }

      return {
        ...state,
        callState: {
          ...state.callState,
          Locations: LoadingState.MUTATED,
          ServiceArea,
        },
      };
    },
  ),
  on(
    JobCreateLocationsActions.addLocationManuallyButtonClicked,
    NewOpportunityLocationsActions.addLocationManuallyButtonClicked,
    (state: JobToolState, { locationType }): JobToolState => {
      return {
        ...state,
        manuallyAddLocationDialogVisible: true,
        manuallyAddLocationDialog: {
          ...jobManuallyAddLocationInitialState.manuallyAddLocationDialog,
          locationType,
        },
      }
    },
  ),
  on(
    JobManuallyAddLocationActions.addLocationButtonClicked,
    (state: JobToolState): JobToolState => {
      return {
        ...state,
        ...jobManuallyAddLocationInitialState,
      };
    },
  ),
  on(
    JobCreateLocationsActions.resolveServiceAreaSuccess,
    (state: JobToolState): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          ServiceArea: LoadingState.LOADED,
        }
      };
    },
  ),
  on(
    JobCreateLocationsActions.resolveServiceAreaError,
    (state: JobToolState, { error }): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          ServiceArea: { error },
        }
      };
    },
  ),
  on(
    JobCreateLocationsActions.headerClicked,
    (state: JobToolState): JobToolState => {

      const collapsedNewOpportunityCards = { ...state.collapsedNewOpportunityCards };

      if (NewOpportunityCard.createLocations in collapsedNewOpportunityCards) {
        delete collapsedNewOpportunityCards[NewOpportunityCard.createLocations]
      } else {
        collapsedNewOpportunityCards[NewOpportunityCard.createLocations] = true;
      }

      return {
        ...state,
        collapsedNewOpportunityCards,
      };
    },
  ),
  on(
    JobCreateActions.jobOriginGainedFocus,
    (state: JobToolState): JobToolState => {

      const collapsedNewOpportunityCards = { ...state.collapsedNewOpportunityCards };

      delete collapsedNewOpportunityCards[NewOpportunityCard.createLocations]

      return {
        ...state,
        collapsedNewOpportunityCards,
      };
    },
  ),
  on(
    JobCreateLocationsActions.updateLocationsSuccess,
    (state: JobToolState): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          Locations: LoadingState.MUTATED,
        }
      }
    },
  ),
  on(
    JobCreateLocationsActions.updateLocationsError,
    (state: JobToolState, { error }): JobToolState => {
      return {
        ...state,
        callState: {
          ...state.callState,
          Locations: { error },
        }
      }
    },
  ),
] as const;
